<template>
    <div>
        <div
            v-if="detail"
            :class="[
                'quote-detail',
                {
                    isPC: !isH5
                }
            ]"
        >
            <div class="detail">
                <div class="title">{{ detail.shortName }} {{ detail.name }}</div>
                <div :class="['price-info', {
                    down: detail.priceChange < 0,
                    redUp: upDownColor !== UP_DOWN_COLOR.GREEN_UP
                }]">
                    <div class="price">{{ detail.price }}</div>
                    <div class="arrow"></div>
                    <div class="priceChange">{{ detail.priceChange }}</div>
                    <div class="ratioPriceChange">{{ detail.ratioPriceChange }}</div>
                </div>
            </div>
            <RealTimeStockChart
                v-if="isMounted"
                class="chart"
                :type="chartType"
                :chartData="chartData"
                :stockInfo="{}"
                :market="1"
                :upDownColor="upDownColor"
                :language="language"
                :loading="loading"
                :chartColor="chartColor"
                @change="change"
            />
        </div>
    </div>
</template>
<script>
import RealTimeStockChart from '@futuweb/quote-charts/lib/RealTimeStockChart';
import '@futuweb/quote-charts/lib/RealTimeStockChart/style/index.css';
import {
    common
} from '@futuweb/fego-render';
import { isH5 } from '../utils';
import { UP_DOWN_COLOR, LANGUAGE } from '../constant.js';

const { request } = common;
const commonApiQuotesChart = request.bindCommonApi('quotes-chart');
const MARKET_TYPE_US = 2; // 美股市场

export default {
    components: {
        RealTimeStockChart
    },
    props: {
        symbol: {
            type: String,
            default: ''
        },
        upDownColor: {
            type: Number,
            default: UP_DOWN_COLOR.GREEN_UP
        },
        language: {
            type: Number,
            default: LANGUAGE.EN
        }
    },
    data() {
        return {
            isH5: isH5(),
            isMounted: false,

            currentSymbol: '',
            chartType: 2,
            type: 2,
            chartColor: {
                splitLineColor: '#E7EAEB',
                tooltipBg: 'rgba(20, 85 ,191 ,.8)',
                axisPointerLine: 'rgb(246, 246, 246)',
                tooltipLabel: '#F6F6F6',
                tooltipValue: '#fff',
                axisLabelColor: '#507EC1',
                dataZoomDataBgLine: '#0091F4', //k线图滑动条里折线的颜色
                dataZoomDataBgArea: '#1455BF', //k线图滑动条里区域的颜色
                dataZoomFillerColor: '#1455BF', //k线图滑动条最上面的icon颜色
                dataZoomHandleColor: '#0091F4', //k线图滑动条两侧的icon颜色
                dataZoomTextColor: '#507EC1', //k线图滑动条两侧文字颜色
                changeColor: { //红涨绿跌的颜色
                    'up': 'rgb(255, 89, 89)',
                    'down': 'rgb(9, 183, 129)',
                    'flat': 'rgb(80, 126, 193)'
                },
                gradientStart:{ //分时图的区域渐变色开始的颜色
                    'up': 'rgba(255, 89, 89, 0.5)',
                    'down': 'rgba(9, 183, 129, 0.5)',
                    'flat': 'rgba(80, 126, 193, 0.5)'
                },
                gradientEnd: { //分时图的区域渐变色结束的颜色
                    'up': 'rgba(255, 89, 89, 0)',
                    'down': 'rgba(9, 183, 129, 0)',
                    'flat': 'rgba(80, 126, 193, 0)'
                }
            },
            loading: false,
            chartData: [],

            detail: null,
            UP_DOWN_COLOR
        };
    },
    async mounted() {
        this.isMounted = true;
        const arr = decodeURIComponent(location.search).match(/symbol=([^\.]+\.[^&]+)/);
        const currentSymbol = this.symbol || arr && arr[1] || '';
        if (!currentSymbol) return;

        this.currentSymbol = currentSymbol;
        await this.getDetail();
        if (this.detail) {
            this.getChartData();
        }
    },
    methods:{
        change(item, index){
            this.chartType = index;
            this.type = item.type;
            this.getChartData();
        },
        async getDetail() {
            const detail = await commonApiQuotesChart.get(`detail`, {
                symbol: this.currentSymbol,
            });
            this.detail = detail;
        },
        async getChartData() {
            let data = null;
            const { detail } = this;
            this.loading = true;
            const isMinute = this.chartType <= 1;
            try {
                if (isMinute) {
                    const params = {
                        symbol: detail.symbol,
                        stock_id: detail.stockId,
                        market_code: detail.marketCode,
                        type: this.type,
                    };
                    if (detail.marketType === MARKET_TYPE_US && detail.instrumentType) {
                        params.req_section = 3;
                    }
                    data = await commonApiQuotesChart.get(`minute`, params);
                } else {
                    data = await commonApiQuotesChart.get(`kline`, {
                        symbol: detail.symbol,
                        stock_id: detail.stockId,
                        type: this.type,
                    });
                }
            } catch (error) {
                console.log(error);
            }
            this.loading = false;
            this.chartData = data || [];
        }
    }
};
</script>
<style lang="less" scoped>
.quote-detail {
    margin: 0 auto;
    &:not(.isPC) {
        .detail {
            margin-bottom: 0.26rem;
            .title {
                font-size: 0.56rem;
                line-height: 0.76rem;
                color: #24262b;
            }
            .price-info {
                display: flex;
                align-items: flex-end;
                color: #00a843;
                &.down {
                    color: #f13e3a;
                }
            }
            .price {
                margin-right: 0.14rem;
                line-height: 1;
                font-size: 0.48rem;
            }
            .arrow {
                margin-right: 0.28rem;
                width: 0.24rem;
                height: 0.28rem;
                font-size: 0;
                background: url('./image/green.svg') no-repeat center;
                background-size: contain;
            }
            .redUp {
                color: #f13e3a;
                &.down {
                    color: #00a843;
                }
            }
            .down .arrow {
                background-image: url('./image/red.svg');
                transform: rotate(180deg);
            }
            .redUp {
                .arrow {
                    background-image: url('./image/red.svg');
                }
                &.down .arrow {
                    background-image: url('./image/green.svg');
                }
            }
            .priceChange {
                margin-right: 0.12rem;
            }
            .priceChange, .ratioPriceChange {
                line-height: 1;
                font-size: 0.24rem;
            }
        }
        .chart {
            padding: 0 0.4rem;
            /deep/ .stock-chart-nav {
                display: none;
            }
        }
    }
    &.isPC {
        .detail {
            margin-bottom: 10px;
            .title {
                font-size: 60px;
                line-height: 60px;
                color: #000;
            }
            .price-info {
                display: flex;
                align-items: center;
                color: #00a843;
                &.down {
                    color: #f13e3a;
                }
            }
            .price {
                margin-right: 8px;
                line-height: 56px;
                font-size: 40px;
            }
            .arrow {
                margin-right: 8px;
                width: 10px;
                height: 11px;
                font-size: 0;
                background: url('./image/green.svg') no-repeat center;
                background-size: contain;
            }
            .redUp {
                color: #f13e3a;
                &.down {
                    color: #00a843;
                }
            }
            .down .arrow {
                background-image: url('./image/red.svg');
                transform: rotate(180deg);
            }
            .redUp {
                .arrow {
                    background-image: url('./image/red.svg');
                }
                &.down .arrow {
                    background-image: url('./image/green.svg');
                }
            }
            .priceChange {
                margin-right: 4px;
            }
            .priceChange, .ratioPriceChange {
                line-height: 28px;
                font-size: 20px;
            }
        }
        .chart {
            padding: 20px;
            /deep/ .stock-chart-nav {
                .stock-chart-li {
                    background-color: #F9F9F9;
                    color: #3F4045;
                    &.current {
                        background-color: #fcf1e6;
                        color: #FF6900
                    }
                }
            }
        }
    }
}
</style>
